import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-combine',
  templateUrl: './combine.component.html',
  styleUrls: ['./combine.component.css']
})
export class CombineComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    // this.btn_call();   
  }

  btn_call()
  {
    document.querySelector('.img__btn').addEventListener('click', function() {
      document.querySelector('.cont').classList.toggle('s--signup');
    });
  }

}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_welcome/combine/combine.component.ts